<template>
    <div class="text-sm">
        <div class>{{ areal.properties.Beskrivelse }}</div>
        <div class=" mt-4">
            <h5>Egnethed</h5>
            {{ areal.properties.Egnethed }}
        </div>
        <div class=" mt-4">
            <h5>Beliggehed</h5>
            {{ areal.properties.Beliggenhed }}
        </div>
        <div class=" mt-4">
            <h5>Reservationer</h5>
            <div>
                <LoadingIndicator class="text-gray-700" v-if="bookings === undefined" />
                <div v-if="bookings && bookings.length == 0">Ingen aktuelle reservationer</div>
                <div v-for="booking in bookings" :key="JSON.stringify(booking)"
                    class="border rounded my-1 p-2 bg-white">
                    <div>
                        <span class="font-semibold">{{ booking.arrangmenetNavn }}</span>
                    </div>
                    <span class="text-xs">{{ formatDate(booking.startTidspunkt) }} - {{
                        formatDate(booking.slutTidspunkt)
                    }}</span>
                </div>
            </div>
        </div>
        <router-link :to="'/ny?fastarealid=' + areal.id">
            <button class="mt-2 bg-blue-100 py-2 text-aak-blue font-semibold rounded-md w-full">Opret ny
                reservation</button>
        </router-link>
    </div>
</template>

<script>
import dayjs from "dayjs"
import 'dayjs/locale/da'
import LoadingIndicator from "./LoadingIndicator.vue"
dayjs.locale('da') // Saet locale i global scope for at det virker
export default {
    components: { LoadingIndicator },
    props: ["areal"],
    data() {
        return {
            bookings: undefined
        };
    },
    methods: {
        formatDate(date) {
            return dayjs(date).format("D. MMMM YYYY HH:mm");
        }
    },
    async created() {
        this.bookings = await fetch(process.env.VUE_APP_API_URL + "/api/ArealBookings/" + this.areal.id).then(res => res.json());
    },
}
</script>